import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $patchStyleText } from '@lexical/selection';
import {
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_EDITOR,
  LexicalCommand,
  createCommand,
} from 'lexical';
import { useEffect } from 'react';

export const CHANGE_HIGHLIGHT_COLOR_COMMAND: LexicalCommand<string> = createCommand('CHANGE_HIGHLIGHT_COLOR_COMMAND');

export default function HighlightColorPlugin(): null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      CHANGE_HIGHLIGHT_COLOR_COMMAND,
      (color: string) => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
          $patchStyleText(selection, { 'background-color': color });
        }
        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );
  }, [editor]);

  return null;
}
